import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackVisit } from "../api";

// Fires a visit event to the backend on every route change (real-time).
// Skips the private admin area.
const VisitTracker = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    trackVisit(pathname, document.referrer || "");
  }, [pathname]);

  return null;
};

export default VisitTracker;
